import createTableStore from "ds/components/Table/store/useTableStore";

import {
  SPACELIFT_VCS_REPO_FILES_COLUMN_CONFIG,
  SPACELIFT_VCS_REPO_FILES_COLUMNS_STORAGE_KEY,
} from "./constants";

const useFilesTableStore = createTableStore({
  storageKey: SPACELIFT_VCS_REPO_FILES_COLUMNS_STORAGE_KEY,
  config: SPACELIFT_VCS_REPO_FILES_COLUMN_CONFIG,
  version: 2,
});

export default useFilesTableStore;
